import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

import { toRefs } from "vue";
import { useLogger } from "vue-logger-plugin";

// Define Component Input Properties

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteStatsCard',
  props: {
    statName: String,
    iconImage: String,
    blurb: String,
    additionalClass: String,
},
  setup(__props) {

const props = __props;



// get back props that we need to use
const { statName, iconImage, blurb, additionalClass } = toRefs(props);
const logger = useLogger();

logger.debug(
    "loading site stats card",
    statName,
    iconImage,
    blurb,
    additionalClass
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(statName))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", { src: _unref(iconImage) }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["blurb", _unref(additionalClass)]),
      innerHTML: decodeURIComponent(_unref(blurb))
    }, null, 10, _hoisted_3)
  ], 2))
}
}

})